// Phone sticky Add to cart (snippets/arcana-sticky-atc.liquid). Mirrors and clicks the real button.
if (!customElements.get('arcana-sticky-atc')) {
  customElements.define(
    'arcana-sticky-atc',
    class ArcanaStickyAtc extends HTMLElement {
      connectedCallback() {
        if (this.closest('quick-add-modal')) return;
        this.sectionId = this.dataset.section;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.button = this.querySelector('[data-sticky-button]');
        this.label = this.querySelector('[data-sticky-label]');
        this.price = this.querySelector('[data-sticky-price]');
        this.button.addEventListener('click', () => this.onClick());

        // Show once the real button has scrolled above the viewport (a fast flick skips any
        // intersection change, so measure on scroll instead of using IntersectionObserver)
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });

        // Dawn re-renders the buy box on variant change: re-sync whenever it does
        const section = document.getElementById(`MainProduct-${this.sectionId}`) || this.parentElement;
        this.mutations = new MutationObserver((records) => {
          // Ignore our own label/price updates (this element lives inside the section)
          if (records.every((record) => this.contains(record.target))) return;
          this.sync();
        });
        this.mutations.observe(section, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
        this.onMedia = () => this.update();
        this.mobile.addEventListener('change', this.onMedia);
        this.sync();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        this.mobile?.removeEventListener('change', this.onMedia);
        this.mutations?.disconnect();
        document.body.classList.remove('arcana-sticky-atc-open');
      }

      realButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      notifyCard() {
        return document.getElementById(`ArcanaNotify-${this.sectionId}`);
      }

      sync() {
        const real = this.realButton();
        this.observed = real;
        if (!real) return this.update();

        this.soldOut = real.hasAttribute('disabled');
        const realLabel = real.querySelector('span')?.textContent.trim();
        const notify = this.notifyCard();
        let label = realLabel;
        let disabled = this.soldOut;
        if (this.soldOut && notify && notify.offsetParent !== null) {
          label = notify.querySelector('[data-arcana-wish-form] button[type="submit"]')?.textContent.trim() || realLabel;
          disabled = false;
        }
        if (this.label.textContent !== label) this.label.textContent = label;
        if (this.button.disabled !== disabled) this.button.disabled = disabled;

        const priceEl = document.querySelector(`#price-${this.sectionId} .price-item--last, #price-${this.sectionId} .price-item--regular`);
        const price = priceEl ? priceEl.textContent.trim() : '';
        if (this.price.textContent !== price) this.price.textContent = price;
        this.update();
      }

      update() {
        const real = this.observed && this.observed.isConnected ? this.observed : this.realButton();
        const show = Boolean(this.mobile.matches && real && real.getBoundingClientRect().bottom < 0);
        if (this.hidden !== !show) this.hidden = !show;
        document.body.classList.toggle('arcana-sticky-atc-open', show);
      }

      onClick() {
        const real = this.realButton();
        if (!real) return;
        if (this.soldOut) {
          const notify = this.notifyCard();
          if (!notify) return;
          notify.scrollIntoView({ behavior: 'smooth', block: 'center' });
          notify.querySelector('input[type="email"]')?.focus({ preventScroll: true });
          return;
        }
        real.click();
      }
    }
  );
}
